export const environment = {
    cemsRootUrl: 'https://api-cems.test.epa.ohio.gov',
    clientID: 'c1b1bfcb-624e-46db-b7aa-d02873718961',
    redirectURI: 'https://cems.test.epa.ohio.gov/',
    ohioId: '' // Local development Ohio ID
};
